export function CoreNumberDirective () {
  
  function isEmpty(value) {
    if (value == null || value == NaN || value == undefined || value == "") return true;
    else return false;
  };

  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ctrl) {

      ctrl.$parsers.push(function(value) {
        //convert data from view format to model format
        if (isNaN(value) && value !== '-') {
          ctrl.$setValidity('$valid', false);
          ctrl.$viewValue = '';
          ctrl.$render();
          return attrs.allowNull ? '': 0
        }
        else if (isEmpty(value)) {
          ctrl.$setValidity('$valid', true);
          ctrl.$setValidity('$range', true);
          ctrl.$viewValue = '';
          ctrl.$render();
          return attrs.allowNull ? '': 0
        }
        else {
          if (!attrs.min || !attrs.max) {
            ctrl.$setValidity('$valid', true);
            ctrl.$render();
            return value
          }
          if ( (parseFloat(value) >= parseFloat(attrs.min)) && (parseFloat(value) <= parseFloat(attrs.max)) ) {
            ctrl.$setValidity('$valid', true);
            ctrl.$setValidity('$range', true);
            ctrl.$render();
            return value
          }
          else {
            ctrl.$setValidity('$valid', false);
            ctrl.$setValidity('$range', false);
            ctrl.$render();
            return value
          }
        }
      });

      ctrl.$formatters.push(function(value) {

        //convert data from model format to view format
        if (isEmpty(value)) return "";
        if (isNaN(value)) return "";
        else return value
      });
    }
  }
}